const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.612,
    height: 12.58,
    viewBox: "0 0 11.612 12.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 240870"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 293013",
    d: "M64.709 56v9.193a.484.484 0 0 1-.484.484h-7.741a.484.484 0 0 1-.484-.484V56z",
    transform: "translate(-54.548 -53.581)",
    style: {
      opacity: 0.2,
      fill: "#a10000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 293014",
    d: "M43.129 17.935H32.484a.484.484 0 0 0 0 .968h.484v8.709a.968.968 0 0 0 .968.968h7.742a.968.968 0 0 0 .968-.968V18.9h.484a.484.484 0 0 0 0-.968zm-1.452 9.677h-7.742V18.9h7.742zM34.9 16.484a.484.484 0 0 1 .487-.484h4.838a.484.484 0 0 1 0 .968h-4.838a.484.484 0 0 1-.487-.484z",
    style: {
      fill: "#a10000"
    },
    transform: "translate(-32 -16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.f9a230fa592be542022815ef1987325e.svg";
export { ForwardRef as ReactComponent };